import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"
import Moment from "moment"

export const getSalesQuotation = async (info) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "sales_quotations/get",
      {
        requester: getUser(),
        token: getToken(),
        sales_quotation_id: info.id,
        branch_id: info.branch_id,
        customer_id: info.customer_id,
        customer_name: info.customer_name,
        status: info.status,
        anything: info.anything,
        date_from: info.date_from
          ? Moment(info.date_from).format("YYYY-MM-DD")
          : info.date_from,
        date_to: info.date_to
          ? Moment(info.date_to).format("YYYY-MM-DD")
          : info.date_to,
        page: info.page,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//POST
export const createSalesQuotation = async (data, items) => {
  let form_data = new FormData()
  form_data.append("requester", getUser())
  form_data.append("token", getToken())
  form_data.append("customer_id", data.customer_id)
  form_data.append("branch_id", data.branch_id)
  form_data.append("valid_from", data.valid_from)
  form_data.append("valid_to", data.valid_to)
  form_data.append("delivery_date", data.delivery_date)
  form_data.append("delivery_fee", data.delivery_fee)
  form_data.append("service_fee", data.service_fee)
  form_data.append("ship_via", data.ship_via)
  form_data.append("contact_no", data.contact_no)
  form_data.append("address", data.address)
  form_data.append("remarks", data.remarks ? data.remarks : "")
  form_data.append("grand_total", data.grand_total)
  form_data.append("status", data.status)
  items.map((item) => {
    form_data.append(`item_id[]`, item.item_id ? item.item_id : "")
    form_data.append(`description[]`, item.description ? item.description : "")
    form_data.append(`item_name[]`, item.item_name ? item.item_name : "")
    form_data.append(
      `item_unit_id[]`,
      item.item_unit_id ? item.item_unit_id : ""
    )
    form_data.append(`unit[]`, item.unit ? item.unit : "")
    form_data.append(`price[]`, item.price ? item.price : "")
    form_data.append(`qty[]`, item.qty ? item.qty : "")
    form_data.append(`subtotal[]`, item.subtotal ? item.subtotal : "")
    form_data.append(`item_remarks[]`, item.item_remarks || "")
    form_data.append(`discount[]`, item.discount ? item.discount : 0)
    form_data.append(`discount_amount[]`, item.discount_amount || 0)
  })
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_quotations/create",
      form_data
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
  // try {
  //     var payload = {
  //         requester: getUser(),
  //         token: getToken(),
  //         branch_id: data.branch_id,
  //         valid_from: data.valid_from,
  //         valid_to: data.valid_to,
  //         delivery_date: data.delivery_date,
  //         delivery_fee: data.delivery_fee,
  //         service_fee: data.service_fee,
  //         ship_via: data.ship_via,
  //         contact_no: data.contact_no,
  //         address: data.address,
  //         remarks: data.remarks,
  //         grand_total: data.grand_total,
  //         status: data.status,
  //     };

  //     const response = await postAPICall(
  //         process.env.REACT_APP_LINK + "sales_quotations/create",
  //         payload
  //     );

  //     return { data: response.data };
  // } catch (error) {
  //     return { error: error.response };
  // }
}

export const updateSalesQuotation = async (data, items) => {
  let form_data = new FormData()
  form_data.append("requester", getUser())
  form_data.append("token", getToken())
  form_data.append("sales_quotation_id", data.id)
  form_data.append("branch_id", data.branch_id)
  form_data.append("valid_from", data.valid_from)
  form_data.append("valid_to", data.valid_to)
  form_data.append("customer_id", data.customer_id_value.value)
  form_data.append("delivery_date", data.delivery_date)
  form_data.append("delivery_fee", data.delivery_fee)
  form_data.append("service_fee", data.service_fee)
  form_data.append("ship_via", data.ship_via)
  form_data.append("contact_no", data.contact_no)
  form_data.append("address", data.address)
  form_data.append("remarks", data.remarks ? data.remarks : "")
  form_data.append("grand_total", data.grand_total)
  form_data.append("status", data.status)
  items.map((item) => {
    if (item.discount === 0) {
    } else {
    }
    form_data.append(`sales_quotation_item_id[]`, item.id ? item.id : "")
    form_data.append(`item_id[]`, item.item_id ? item.item_id : "")
    form_data.append(`description[]`, item.description ? item.description : "")
    form_data.append(`item_name[]`, item.item_name ? item.item_name : "")
    form_data.append(
      `item_unit_id[]`,
      item.item_unit_id ? item.item_unit_id : ""
    )
    form_data.append(`unit[]`, item.unit ? item.unit : "")
    form_data.append(`price[]`, item.price ? item.price : "")
    form_data.append(`discount[]`, item.discount ? item.discount : 0)
    form_data.append(`qty[]`, item.qty ? item.qty : "")
    form_data.append(`subtotal[]`, item.subtotal ? item.subtotal : "")
    form_data.append(`item_remarks[]`, item.item_remarks || "")
  })
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_quotations/update",
      form_data
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const deleteSalesQuotation = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_quotations/delete",
      {
        requester: getUser(),
        token: getToken(),
        sales_quotation_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const closeSalesQuotation = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_quotations/mark_closed",
      {
        requester: getUser(),
        token: getToken(),
        sales_quotation_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const emailSalesQoutation = async (id, file) => {
  const formData = new FormData()
  formData.append("requester", getUser())
  formData.append("token", getToken())
  formData.append("id", id)
  formData.append("attachment", file)

  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "emails/send_sales_quotation",
      formData
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
